/*
 * Project: LegalPlace assistant
 * File: src\redux\reducers\section.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import { ADD_SECTION } from '../actions/section';
// options
import { addOption } from '../actions/option';
import optionReducer from './option';
import { store } from '../../globals';
import writeHistory from '../../logic/history';
import lpApp from '../../app/lp_app';

export default function rSection(state = {
  label: '',
  option_ids: [],
  id: 1,
  conditional: false,
  compiled_condition: [],
}, action) {
  switch (action.type) {
    case ADD_SECTION:
    {
      const { section } = action;
      const { sId, isaNav } = action;
      const redirCondition = isaNav === undefined ? true : isaNav;

      const result = {
        label: section.label,
        option_ids: section.options,
        id: section.id,
      };
      const options = result.option_ids.map(el => optionReducer({}, addOption(el)));
      if (section.compiledConditions && section.compiledConditions.length > 0) {
        result.conditional = true;
        result.compiled_condition = section.compiledConditions;
      } else {
        result.conditional = false;
        result.compiled_condition = null;
      }
      result.options_render = options;

      return result;
    }
    default:
    {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/section.js